import localforage from 'localforage';
import { v4 as uuidv4 } from 'uuid';
import { hashPassword } from '../utils/browserSecurity';
import userStore from './userStore';

export async function seedAuthUsers() {
  // Remove ALL users with username or email matching 'admin' or 'user' (case-insensitive, trimmed)
  const allKeys = await userStore.keys();
  const seen = new Set();
  for (const key of allKeys) {
    const user = await userStore.getItem(key);
    if (user) {
      const uname = (user.username || '').trim().toLowerCase();
      const email = (user.email || '').trim().toLowerCase();
      // Remove duplicates (keep only the first occurrence of each username/email)
      const uniqueKey = uname + '|' + email;
      if ((uname === 'admin' || uname === 'user' || email === 'admin@sharedoxygen.com' || email === 'user@sharedoxygen.com')) {
        if (seen.has(uniqueKey)) {
          await userStore.removeItem(key);
        } else {
          seen.add(uniqueKey);
        }
      }
    }
  }

  // After removing duplicates, check if admin/user exist; if not, add them
  const usersToSeed = [
    {
      username: 'admin',
      password: await hashPassword('shaoxy-$3cur3'),
      email: 'admin@sharedoxygen.com',
      role: 'admin',
      isActive: true,
      twoFactorEnabled: false
    },
    {
      username: 'user',
      password: await hashPassword('shaoxy-$3cur3'),
      email: 'user@sharedoxygen.com',
      role: 'user',
      isActive: true,
      twoFactorEnabled: false
    }
  ];

  const currentKeys = await userStore.keys();
  const currentUsers = await Promise.all(currentKeys.map(key => userStore.getItem(key)));
  for (const user of usersToSeed) {
    const uname = user.username.trim().toLowerCase();
    const email = user.email.trim().toLowerCase();
    const exists = currentUsers.some(u =>
      u && (
        (u.username && u.username.trim().toLowerCase() === uname) ||
        (u.email && u.email.trim().toLowerCase() === email)
      )
    );
    if (!exists) {
      await userStore.setItem(uuidv4(), {
        ...user,
        id: uuidv4(),
        createdAt: new Date().toISOString()
      });
    }
  }
}

// Auto-run on app start
seedAuthUsers();
